<h2 mat-dialog-title class="">{{data?.title}}</h2>
<mat-dialog-content>
    <ng-container *ngIf="data.mode !== 'delete'; else deleteMode">
        <div class="row mb-3 p-3 w-100">
            <form [formGroup]="form" class="row g-3">
                <div class="col-lg-6 mb-3">
                    <label for="name" class="form-label required-field">Nombre</label>
                    <input type="text" id="name" class="form-control" formControlName="name" required/>
                    <app-form-errors [controlName]="form.controls['name']"></app-form-errors>
                </div>
                <div class="col-lg-6 mb-3">
                    <label for="stateId" class="form-label required-field">Provincia</label>
                    <select id="stateId" class="form-select" formControlName="stateId" aria-placeholder="Seleccione un país" required>            
                        <option *ngFor="let item of stateList" [value]="item.id">
                        {{ item.name }}
                        </option>
                    </select>      
                    <app-form-errors [controlName]="form.controls['stateId']"></app-form-errors>
                </div>
            </form>
        </div>
    </ng-container>
    <ng-template #deleteMode>
        <div class="">
            <div class="">
                <h5>¿Seguro que quieres eliminar?</h5>
            </div>
        </div>
    </ng-template>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button class="btn btn-primary btn-lg me-3" (click)="Accept()">{{data.mode === 'delete' ? 'Eliminar' : 'Guardar'}}</button>
    <button mat-button class="btn btn-danger btn-lg" (click)="closeDialog()">Cancelar</button>
</mat-dialog-actions>